/*
 * @Author: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @Deion:
 * @Date: 2022-09-15 10:17:58
 * @LastEditors: guanxiaoyan guanxiaoyan@pb-station.com
 * @LastEditTime: 2025-04-21 15:49:06
 * @FilePath: /ywx-open/vueproject/src/utils/routeHooks.js
 */
// 权限校验文件,用于权限校验
import Vue from 'vue'
import vuex from 'vuex'

import VueCookies from 'vue-cookies'

import router from '@/router/index'
import store from '@/store/index'
import API from '@szyx/axios'
import { accountType, envTypeData } from '@/utils/public'

Vue.use(VueCookies)
Vue.use(vuex)
// 添加不需要重定向的白名单,填写命名
// const whiteList = ['login'];

router.beforeEach( async (to, from, next) => {
  console.log("router=",router.options.routes)
  store.commit('loginStore/SET_ActiveIndex', to.path)
  if (to.meta && to.meta.activeMenu) {
    // 随访跳转详情页需选中当前指定菜单
    store.commit('loginStore/SET_ActiveIndex', to.meta.activeMenu)
  }
  // 拦截请求，判断是否登录 根据cookie是否有username和uniqueid进行判断
  const userLoginInfo = VueCookies.get('userLoginInfo')

  // 获取登陆账号类型
  const loginType = userLoginInfo && Object.keys(userLoginInfo).length
  ? userLoginInfo.type
  : null

   // 代理商子账号(权限配置) / 代理商(全部权限)
  let rolePermissions = []
  let rolePermissionsAll = []
  if(loginType == accountType.sales || loginType == accountType.agent){
    console.log( VueCookies.get('permissions'))
    const permissions = VueCookies.get('permissions');
    const permissionsList = permissions ? permissions.split(',') : []
    rolePermissions = setrolePermissionsAll(permissionsList)
    rolePermissionsAll = setrolePermissionsAll(permissionsList)
  }
  // console.log(rolePermissions)
  // console.log(rolePermissionsAll)
  const envType = VueCookies.get('envType')
  const currentClientId = VueCookies.get('currentClientId')
  if (to.name === 's1' || to.name === 's2' || to.name === 's3') {
    next()
  } else if (
    !userLoginInfo ||
    !userLoginInfo.username ||
    !envType ||
    (envType !== envTypeData.noneEnv && !currentClientId)
  ) {
    // 此处应执行退出并返回首页再次去登录
    VueCookies.remove('userLoginInfo')
    VueCookies.remove('envType')
    VueCookies.remove('envApi')
    VueCookies.remove('currentClientId')
    VueCookies.remove('username')
    VueCookies.remove('defaultEnvOfTwo')
    window.location.href = '../homeList/homePage.html'
  } else {
    let arrs = []
    if (envType && loginType===accountType.factory && envType === envTypeData.noneEnv) {
      // 两个环境都没有,只展示概览
      arrs = ['1']
    } else {
      switch (loginType) {
        // 厂商
        case accountType.factory: {
          // 点击应用入口
          // 公共 ['1. 账户概览', '110.平台应用']
          let isGoHome = true;
          let currentApp = ''; // 当前访问的应用模块
          const common = ['1', '110'];
          if (common.some(num => `${num}` === `${to.meta.idthat}`)) {
            isGoHome = false;
            arrs = common;
          }
          // 医网签
          let ywq = ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
          // if(VueCookies.get('justSZRZ')==='true'){
          //   // 去掉患者签名
          //   ywq= ywq.filter((m)=>m!=='7')
          // }
          if (ywq.some(num => `${num}` === `${to.meta.idthat}`)) {
            arrs = ywq;
            currentApp = 'ywq';
          }
          // 随访（新）
          const followUp = ['800', '820', '840'];
          if (followUp.some(num => `${num}` === `${to.meta.idthat}`)) {
            arrs = followUp;
          }
          // 电子合同--暂时写死，厚度按未给值
          const eleContract = ['10000','10001','10002','10003','10004', '10005']
          if (eleContract.some(num => `${num}` === `${to.meta.idthat}`)) {
            arrs = eleContract;
          }
          store.dispatch('app/SET_GO_HOME', isGoHome);
          store.dispatch('app/SET_CURRENT_APP', currentApp);
          break
        }
        // 代理商
        case accountType.agent: {
          // arrs = ['000', '001', '002', '003', '004']
          arrs = [...rolePermissionsAll, '004']
          break
        }
        // 销售商
        case accountType.sales: {
          // arrs = ['11', '13', '14']
          arrs = rolePermissions
          break
        }
        default:
          arrs = []
      }
    }
    // 渲染菜单
    const menuShowFn = (routes) => {
      if (!routes) return;
      routes.forEach(route => {
        let idthat = '';
                // eslint-disable-next-line prefer-destructuring
        if (route && route.idthat) idthat = route.idthat;
                // eslint-disable-next-line prefer-destructuring
        if (route && route.meta && route.meta.idthat) idthat = route.meta.idthat;
        if (route.menuShow !== undefined && route.menuShow !== null && route.menuShow !== '') {
                  // eslint-disable-next-line prefer-destructuring
          route.menuShow = arrs.some(id => (id === idthat && !route.clientId) || route?.clientId?.includes(store.getters.currentClientId))
        }
        if (route.children && route.name){
          menuShowFn(route.children)
        }
      })
    };
    arrs.length && menuShowFn(router.options.routes);
    next()
  }
})

function setrolePermissionsAll(list) {
  let rolePermissions=[]
  list.map(item => {
    rolePermissions.push(item)
  })
  return rolePermissions
}

function setRolePermissions(list) {
  let rolePermissions=[]
  list.map(item => {
    if(item.length === 3) {
      rolePermissions.push(item)
    }
  })
  return rolePermissions
}

// 请求角色权限列表
function getPermissions() {
  const userLoginInfo = VueCookies.get('userLoginInfo')
  API.getPermissionsByRoleId(
    {
      roleId: 2,
    })
    .then((result) => {
      if (!this.$API.ApiRequest(result)) {
        return
      }
      console.log(result);
      return result.data
    })
}

router.afterEach(() => {
  //   console.log('跳转成功');
})
